export default __webpack_public_path__ + "static/media/TL05.1.ee2f3a62.mp3";